import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase/config';
import { UserManagementPort, CreateUserData, UpdateUserData } from '../../domain/ports/UserManagementPort';
import { RepositoryError } from '../../domain/errors';
import { ILoggerService } from '../../domain/services/LoggerService';

export class FirebaseUserManagementAdapter implements UserManagementPort {
  private readonly prefix = 'users';
  private readonly logger: ILoggerService;

  constructor(logger: ILoggerService) {
    this.logger = logger;
  }

  async createUser(data: CreateUserData): Promise<void> {
    const startTime = Date.now();
    const functionName = `${this.prefix}-createUser`;
    this.logger.logRepositoryRequest('UserManagementAdapter', 'createUser', { functionName, data });
    
    try {
      const createUserFn = httpsCallable(functions, functionName);
      const result = await createUserFn(data);
      
      if (!result.data || !(result.data as any).success) {
        throw RepositoryError.queryFailed();
      }

      const duration = Date.now() - startTime;
      this.logger.logRepositoryResponse('UserManagementAdapter', 'createUser', duration, { success: true });
    } catch (error: any) {
      const duration = Date.now() - startTime;
      this.logger.logRepositoryError('UserManagementAdapter', 'createUser', duration, error);
      console.error('Create user error:', error);
      
      if (error.details?.code) {
        throw new RepositoryError(error.details.code);
      }
      
      throw RepositoryError.queryFailed();
    }
  }

  async updateUser(data: UpdateUserData): Promise<void> {
    const startTime = Date.now();
    const functionName = `${this.prefix}-updateUser`;
    this.logger.logRepositoryRequest('UserManagementAdapter', 'updateUser', { functionName, data });
    
    try {
      const updateUserFn = httpsCallable(functions, functionName);
      const result = await updateUserFn(data);
      
      if (!result.data || !(result.data as any).success) {
        throw RepositoryError.queryFailed();
      }

      const duration = Date.now() - startTime;
      this.logger.logRepositoryResponse('UserManagementAdapter', 'updateUser', duration, { success: true });
    } catch (error: any) {
      const duration = Date.now() - startTime;
      this.logger.logRepositoryError('UserManagementAdapter', 'updateUser', duration, error);
      console.error('Update user error:', error);
      
      if (error.details?.code) {
        throw new RepositoryError(error.details.code);
      }
      
      throw RepositoryError.queryFailed();
    }
  }
}